import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import List from 'components/List';
import TableResponsive from 'components/layout/TableResponsive';
import UpdateNew from "components/layout/updates/UpdateNew";
import UpdateEdit from "components/layout/updates/UpdateEdit";
import SimplePrompt from "components/layout/SimplePrompt";
import IntlDate from "components/layout/IntlDate";
import {deleteUpdateNotificationR} from "actions/ListActions";


class Updates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNew: false,
      showEdit: false,
      editUpdateId: "",
    };
  }

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;

    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: null, name: messages.update_notification },
        ]}
        className="p-t-0"
      />
    );
  };

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  deleteUpdate = (id) => {
   this.props.deleteUpdateNotificationR(id);
  }

  showEdit = (id) => {
    this.setState({editUpdateId: id}, () => {
      this.setState({ showEdit: true });
    })
  };

  closeEdit = () => {
    this.setState({ showEdit: false });
  };

  render() {
    const {
      intl: { messages },
      list,
    } = this.props;

    const { showNew } = this.state;

    const headers = {
      name: messages.name,
      dateFrom: messages.date_from,
      dateTo: messages.date_to,
      actions: messages.actions,
    };

    const rows = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const update = list.data.list[i];
      const { name, date_from, date_to } = update;
      const dateFrom =  <IntlDate date={update.date_from} />
      const dateTo =  <IntlDate date={update.date_to} />

      const actions = [
        <Button className="btn-rounded m-r-10" bsSize="sm" bsStyle="warning" key="join" onClick={() => { this.showEdit(list.data.list[i].id) }}>
          {messages.edit}
        </Button>,
        <SimplePrompt className="btn-rounded m-l-5 m-t-5 m-b-5"
                      onSuccess={e => this.deleteUpdate(list.data.list[i].id)}
        />
      ];

      const rowData = {
        name,
        dateFrom,
        dateTo,
        actions,
      };

      rows.push(rowData);
    }

    const resultTable = list.pending || this.props.pendingUp ? <Loader /> : <TableResponsive headers={headers} rows={rows} />;

    return (
      <DocMeta tags={generateMetaTags(messages.update_notification_meta)}>
        <List
          listName="updates"
          url="/api/updates.json"
          list={list}
          title={messages.update_notification}
          iconClass="fal fa-times-circle"
          showSearch
          sortOptions={['relevance,desc','cdate,desc']}
          breadcrumb={this.getBreadcrumb()}
          newText={messages.new_update_notification}
          newAction={this.showNew}
          showNew
        >
          <div id="item-new">
            <UpdateNew show={this.state.showNew} close={this.closeNew}/>
          </div>
          <div id="item-new">
            <UpdateEdit show={this.state.showEdit} close={this.closeEdit} id={this.state.editUpdateId}/>
          </div>
          {resultTable}
        </List>
      </DocMeta>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    deleteUpdateNotificationR: (id) => {
      dispatch(deleteUpdateNotificationR(id));
    },
  };
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    list: state.list.updates,
    pendingUp: state.list.updates.pendingUp
  };
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(Updates)));
